// extracted by mini-css-extract-plugin
export default {"menu":"Nav-Menu_menu__vo16Q","item":"Nav-Menu_item__-vspF","name":"Nav-Menu_name__S9mXk","icon":"Nav-Menu_icon__nVUoB","activeItem":"Nav-Menu_activeItem__iFF7C"};